import $ from 'jquery';
import ko from 'knockout';

function render(element, bindingOptions, predicate) {
  const html = predicate.template()({
    i18n: bindingOptions.i18n,
  });
  const $inner = $('<div/>').html(html);
  const oldInner = $(element).children()[0];

  if (oldInner) {
    ko.cleanNode(oldInner);
  }

  $(element).empty().append($inner);
  ko.applyBindings(predicate, $inner[0]);
}

export default ko.bindingHandlers.predicateValue = {

  init: (element, valueAccessor, allBindings) => {
    const predicate = valueAccessor();
    const bindingOptions = allBindings();
    const rebindObservable = predicate.property;

    render(element, bindingOptions, predicate);

    rebindObservable.subscribe(() => {
      render(element, bindingOptions, predicate);
    });

    return {
      controlsDescendantBindings: true,
    };
  },
};
